import { Hero } from "@/components/Hero";
import { AlbumWall } from "@/components/AlbumWall";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <AlbumWall />
    </div>
  );
}
